import React from 'react';

const ObjectiveIcon = () => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 480 480" xmlSpace="preserve">
<g>
	<g>
		<path d="M466.422,463.407L249.996,216.602v-50.199h139.251c3.896,0,7.437-2.263,9.074-5.798c1.637-3.535,1.072-7.699-1.448-10.67
			L361.818,108.6l34.351-38.665c2.615-2.943,3.26-7.147,1.647-10.739c-1.614-3.592-5.185-5.902-9.122-5.902H249.996v-9.998
			c7.903-3.534,13.428-11.476,13.428-20.69C263.424,10.142,253.28,0,240.811,0c-12.477,0-22.628,10.142-22.628,22.606
			c0,8.571,4.781,16.044,11.813,19.89v174.6L13.591,462.909c-2.595,2.948-3.224,7.142-1.609,10.721
			c1.615,3.58,5.176,5.882,9.103,5.887L458.892,480c0.004,0,0.007,0,0.011,0c3.923,0,7.485-2.294,9.106-5.868
			C469.633,470.556,469.012,466.36,466.422,463.407z M249.996,73.294h116.436l-25.246,28.417h-91.19V73.294z M249.996,121.71h96.717
			l20.941,24.692H249.996V121.71z M240.203,235.769l76.871,87.661l-34.945,30.185l-23.312-36.472
			c-1.632-2.553-4.333-4.228-7.345-4.556c-3.013-0.325-6.011,0.728-8.153,2.871l-55.559,55.568l-25.023-47.264L240.203,235.769z
			 M43.202,459.541l105.403-119.726l27.815,52.537c1.485,2.805,4.213,4.738,7.352,5.21c0.496,0.074,0.993,0.111,1.487,0.111
			c2.632,0,5.182-1.04,7.071-2.93l56.335-56.345l22.832,35.722c1.563,2.445,4.111,4.091,6.982,4.51
			c2.872,0.417,5.783-0.43,7.98-2.328l43.8-37.834l106.552,121.508L43.202,459.541z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
  );
};

export default ObjectiveIcon;
